import useToggle from './useToggle'
import useDisablePageScroll from './useDisablePageScroll'

export default function useModal(defaultIsOpen) {
  const {isOpen, open, close, toggle} = useToggle(defaultIsOpen)

  useDisablePageScroll(isOpen)

  return {isOpen, open, close, toggle}
}
